export const OPPORTUNITIES_TYPES = 'BACKBOX_TO_BOOST'
